import * as React from 'react';
import { SearchInput, TextInput } from 'react-admin';

const locationFilters = [
    <SearchInput source="search" alwaysOn />,
    <TextInput source="name" />,
    <TextInput source="address" />,
];

export default locationFilters;